<template>
  <div class="ban-container">
    <div class="ban-container__block">
      <img :src="banImgUrl" />

      <span class="ban-container__title">{{ $t("no_access") }}</span>
      <div class="ban-container__buttons mt-4">
        <a href="https://telegram.me/Robert_ph" target="_blank" class="btn light-blue">@Robert_ph</a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "UserBan",
  computed: {
    ...mapGetters({
      isDarkTheme: "user/isDarkTheme",
    }),
    banImgUrl() {
      return this.isDarkTheme ? require("@/assets/images/icons/user-ban-dark.svg") : require("@/assets/images/icons/user-ban.svg");
    },
  },
};
</script>
<style lang="scss" scoped>
.ban-container {
  width: 100%;
  min-height: 75vh;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f9;
  border-radius: 15px;
  padding: 25px;

  &__block {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    color: #000109;
  }

  &__title {
    font-size: 26px;
    font-weight: 700;
    text-align: center;

    @media (max-width: 767px) {
      font-size: 22px;
    }
  }

  &__text {
    font-size: 18px;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 22px;
  }
}
</style>
